import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectCurrentUserRole, selectIsAuthenticated } from '../../auth/redux/slice';
import { ROUTES } from '../constants';
import { Unauthorized } from './Unauthorized';

export type ProtectedRouteProps = {
    roles?: string[];
    children: React.ReactNode | React.ReactNode[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = (props) => {
    const { roles, children } = props;
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const currentUserRole = useSelector(selectCurrentUserRole);
    const location = useLocation();

    // Sep 2026 - "logging back in always lands on Home instead of known previous page" - the
    // attempted location (path + query string) is handed to SignIn.tsx via router state, so it can
    // return the user there after a successful sign-in instead of hardcoding '/'. Only taken when
    // this redirect is actually the reason we're navigating to sign-in - if the user is ALREADY on
    // /signin (e.g. session expired while they were sitting on it) there's no location worth saving.
    //
    // "as soon as I enter the credentials.. I see this.. signed out of session" - /signout is ITSELF
    // wrapped in ProtectedRoute and dispatches unauthorized() on mount (SignOut.tsx), so landing here
    // FROM /signout (e.g. an intentional sign-out, or a session that lapsed while sitting on that
    // page) would stash '/signout' as `from` - sign back in, get bounced straight back to /signout,
    // which immediately signs out again. /signout (and its variants) are action-only pages, never a
    // legitimate destination to return to, so they're excluded from being remembered here.
    const from = `${location.pathname}${location.search}`;
    const isSignOutRoute = location.pathname === ROUTES.SignOut;
    if(!isAuthenticated)
        return <Navigate to={ROUTES.SignIn} state={isSignOutRoute ? undefined : { from }} replace />;

    console.log('Authorized?',roles !== undefined && !roles!.some(role => role === currentUserRole))
    if(roles !== undefined && !roles!.some(role => role === currentUserRole))
        return <Unauthorized />
    
    return (
        <>
        {children}
        </>
    );
}